export default {
  snackbar: {
    message: "",
    variant: null,
    title: null,
    position: "b-toaster-bottom-right",
    duration: 3400,
  },
  sidebar: {
    close: false,
    sticky: true,
    // activeElement: "dashboard",
  },
  supportArticleDrawer: {
    open: false,
    articleSlug: null,
  },
  supportLanding: {
    open: false,
  },
  pricingTool: {
    open: false,
    // Bumped on every request to open the panel, including while it is already open, so each one starts fresh.
    openRequest: 0,
    // A saved query waiting to be loaded into the panel.
    pendingSaved: null,
    // Bumped when saved queries change, so the panel and the management page both refresh.
    savedRevision: 0,
  },
  pendingActiveChatMessage: null,
  feedbackAlertCount: 0,
  dashboardOnboardPopupShown: false,
  theme: "dark",
  navUIKey: 1,
  onboarding: false,
};
